import { render, staticRenderFns } from "./BuyLimits.vue?vue&type=template&id=679a4026&"
import script from "./BuyLimits.vue?vue&type=script&lang=js&"
export * from "./BuyLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports